// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__IO7-5","content":"AppLayout_content__kucIO"};